import React from 'react';
import { Inbox } from 'lucide-react';

// Parametrized empty-list illustration for admin/driver screens (no
// bookings/drivers). Purely additive — the `.length === 0` conditionals it
// replaces don't have any other markup depending on them.
function EmptyState({ icon: Icon = Inbox, label = 'Nothing here yet' }) {
  return (
    <div className="empty-state">
      <div className="empty-state-icon">
        <Icon size={28} />
      </div>
      <p className="empty-state-label">{label}</p>
    </div>
  );
}

export default EmptyState;
